module.exports = "https://cdn.hellotech.com/client-assets/printers_tablet_ce44d33bd450ac70862fafb42641953c.png";